import BulkAddModal from './BulkAddModal';

export default BulkAddModal;
